import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { Nav_Interface } from 'src/app/Interface/Nav_Interface';
import { Persone_List_Interface } from 'src/app/Interface/Persone_List_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RoleService {

  constructor(private http: HttpClient) { }

  GetRecord(token: String,fullname: String): Observable<Array<any>>{
    return this.http.get(environment.BaseUrl + "Daro/Role?token="+token
      +"&fullname="+fullname).pipe(
      map(data=>{
        return data as Array<any>
      })
    )
  }


  addeditRole(model: General_Interface,
    Token: String,
    ListMenu: Array<number>,
    ListRoleUser: Array<string>,
    DeviceBehfaRole: Array<number>,
    TicketCategory: Array<number>,
    DataEntity1: Array<number>,
    ListDeviceBehfaRepair: Array<number>): Observable<General_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var modelRole = {
      id:model.id,
      title: model.title,
      username : Token,
      del:false
    }

    var body = {
      model: modelRole,
      ListMenu: ListMenu,
      ListRoleUser: ListRoleUser,
      TicketCategory: TicketCategory,
      ListDeviceBehfaRepair:ListDeviceBehfaRepair,
      DeviceBehfaRole: DeviceBehfaRole,
      DataEntity:DataEntity1,
    }


    return this.http.post(environment.BaseUrl + "Daro/Role/AddEdit",body,{headers}).pipe(
      map(data=>{

        return data as General_Interface
      })
    )

  }


  Delete(token: String,
    id: number): Observable<boolean>{
    return this.http.get(environment.BaseUrl + "Daro/Role/Delete?id="+id
      +"&token="+token).pipe(
      map(data=>{
        return data as boolean
      })
    )
  }


  //#region Access

  GetNav(Token:String,id:number,customer:boolean):Observable<Array<Nav_Interface>>{
    return this.http.get(environment.BaseUrl+ "Daro/Role/GetNav?token="+Token+"&id="+id+"&customer="+customer).pipe(
      map(data=>{
        return data as Array<Nav_Interface>
      })
    )
  }

  GetLetterRole(id: number,Token: String,): Observable<Array<Nav_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Role/GetLetterRole?token=" + Token + "&id=" + id).pipe(
        map(data => {
          return data as Array<Nav_Interface>
        })
      )
  }
  
  GetTicketCategoryUser(id:number,
    Token:String,):Observable<Array<Nav_Interface>>{
    return this.http.get(environment.BaseUrl
      + "Daro/Role/GetTicketCategoryUser?token="+Token
      +"&id="+id).pipe(
      map(data=>{
        return data as Array<Nav_Interface>
      })
    )
  }

  GetDeviceBehfaRepairRole(Token: String, id: number): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/Role/GetDeviceBehfaRepairRole?token=" + Token + "&id=" + id).pipe(
      map(data => {
        return data as any
      })
    )
  }

  GetDeviceBehfaRole(
    id: number,
    Token: String,): Observable<Array<Nav_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/Role/GetDeviceBehfaRole?token=" + Token
      + "&id=" + id).pipe(
        map(data => {
          return data as Array<Nav_Interface>
        })
      )
  }

  GetDataEntity(id:number,
    Token:String,):Observable<Array<Nav_Interface>>{
    return this.http.get(environment.BaseUrl
      + "Daro/Role/GetDataEntity?token="+Token
      +"&id="+id).pipe(
      map(data=>{
        return data as Array<Nav_Interface>
      })
    )
  }

  //#endregion


  //#region Person

  GetPerson(token: String,
    id: number): Observable<Array<Persone_List_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Role/GetPerson?token="+token+"&id="+id).pipe(
      map(data=>{
        return data as Array<Persone_List_Interface>
      })
    )
  }

  
  DeletePerson(token: String,
    id: number): Observable<boolean>{
    return this.http.get(environment.BaseUrl + "Daro/Role/DeletePerson?id="+id
      +"&token="+token).pipe(
      map(data=>{
        return data as boolean
      })
    )
  }

  AddPerson(role_id: number,
    person_id: number,
    Token:String):Observable<any>{
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body = {
      id:0,
      person_id:person_id,
      role_id:role_id,
      token:Token
    }
    return this.http.post(environment.BaseUrl + "Daro/Role/AddPerson",body,{headers}).pipe(
        map(data=>{
          return data as any
        })
    )

  }

  //#endregion


}
